import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconTools from '@/icons/Tools.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const PendingExchangeNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'pending_exchange'>;
}) => {
  const { t } = useLingui();

  const requestReference = notification.request.reference;
  const workshopName = notification.data.onBehalfOfWorkshop?.name;

  return (
    <BaseNotification
      notificationLabel={
        notification.data.onBehalfOfWorkshop
          ? t({
              id: 'notification.pending-exchange.label.on-behalf',
              message: `Pending exchange for request ${requestReference} on behalf of ${workshopName}`,
            })
          : t({
              id: 'notification.pending-exchange.label',
              message: `Pending exchange for request ${requestReference}`,
            })
      }
      icon={<IconTools />}
      type="new"
      notification={notification}
      notificationHeader={(color) =>
        notification.data.onBehalfOfWorkshop ? (
          <Trans id="notification.pending-exchange.on-behalf">
            <InlineText weight="medium" color={color}>
              You
            </InlineText>{' '}
            may notify the workshop{' '}
            <InlineText weight="medium" color={color}>
              {workshopName}
            </InlineText>{' '}
            that the exchange can now begin.
          </Trans>
        ) : (
          <Trans id="notification.pending-exchange">
            <InlineText weight="medium" color={color}>
              You
            </InlineText>{' '}
            have a new exchange to do
          </Trans>
        )
      }
    />
  );
};
